import script from "./componentHeade.vue?vue&type=script&lang=ts&setup=true"
export * from "./componentHeade.vue?vue&type=script&lang=ts&setup=true"

import "./componentHeade.vue?vue&type=style&index=0&id=541a0c96&lang=scss&scoped=true"

import exportComponent from "/opt/jenkins/data/workspace/PRD.standard_checktarget_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-541a0c96"]])

export default __exports__